import { PropsWithChildren, useEffect, FC } from 'react';
import { csManager } from '@shared/utils';
import * as Sentry from '@sentry/react';

export const SessionProvider: FC<PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    const sessionId = csManager.get('SESSION_ID');

    // we want to use the same sessionId for one day or until the user logs out
    if (sessionId) {
      Sentry.setContext('session', { id: sessionId });
    } else {
      const newSessionId = crypto.randomUUID();
      csManager.set('SESSION_ID', newSessionId);
      Sentry.setContext('session', { id: newSessionId });
    }
  }, []);

  return <>{children}</>;
};
